import { StateCreator } from "zustand";
import Swal from "sweetalert2";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, } from "../../base";
import { FetchSpecialitiesMaster } from "../../domain/useages/coverage-reports/fetch-specialities";
import { RemoteFetchSpecialitiesMaster } from "../../data/usecases/coverage-reports/remote-fetch-specialities";
import Endpoints from "../../domain/endpoints";
import { Speciality } from "../../domain/models/speciality";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface FetchSpecialitiesInterface {
  specialitiesData: Speciality[];
  fetchSpecialities: Function;
}

const initialStates = {
  specialitiesData: [],
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchSpecialitiesSlice: StateCreator<
  FetchSpecialitiesInterface
> = (set, get) => ({
  ...initialStates,
  fetchSpecialities: async () => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteFetchSpecialitiesMaster: FetchSpecialitiesMaster =
      new RemoteFetchSpecialitiesMaster(
        `${BASE_URL}${Endpoints.FETCH_SPECIALITIES}`,
        axiosHttpClient
      );

    let result = await remoteFetchSpecialitiesMaster.fetch();

    if (result.success) {
      set(() => ({ specialitiesData: result.specialities }));
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: "Error Occured While Fetching Speciality Data",
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },

});
